export type UserType = {
  id: number;
  username: string;
  name: string;
  email: string;
  phone: string;
  status: string;
  userType?: string;
  client?: string;
  inspectionFirm?: string;
  title?: string;
  company?: string;
  companyType?: string;
  role?: string;
  subrole?: string;
  billingContact?: string;
  accountingContact?: string;
  lastLogin?: string;
};

export type UsersStateType = {
  data: UserType[];
};

export const ADD_USER = "ADD_USER";
